import { createGamesListName } from '@/helpers/game';
import { getGamesCurrenciesKey } from './getGamesCurrencies';
import type { IGamesListKeyContext } from './types';

const GUEST_PLAYER_KEY = 'guest';

export const getGamesPlayerKey = ({ user }: IGamesListKeyContext) =>
  String(user?.id ?? GUEST_PLAYER_KEY);

export const getGamesListKey = (
  context: IGamesListKeyContext,
  param: string,
  subName?: string
) =>
  `${createGamesListName(param, subName)}|${getGamesPlayerKey(context)}|${getGamesCurrenciesKey(context)}`;
